import React from 'react';
import * as S from './PaymentPageLoader.styles';
import LineLoader from '../../../../../stories/core-components/LineLoader/LineLoader';

const BookingPageLoader = () => {
  return (
    <section id="paymentPageLoader">
      

      <S.PageWrapper>
        <S.LeftWrapper>
          
          

          <S.ReviewCardWrap>
            
            <S.ReviewCard>
              <S.TabLabel>
                <span><LineLoader width="20rem" height="2rem"/></span>
              </S.TabLabel>
              <S.TabContent>
                <S.ContentRow>
                    <LineLoader width="30rem" height="2rem"></LineLoader>
                </S.ContentRow>
                <S.ContentRow>
                    <LineLoader width="8rem" height="2rem"></LineLoader>
                    <LineLoader width="4rem" height="2rem"></LineLoader>
                </S.ContentRow>
                <S.ContentRow>
                    <LineLoader width="20rem" height="2rem"></LineLoader>
                </S.ContentRow>
              </S.TabContent>
            </S.ReviewCard>

      
            
          </S.ReviewCardWrap>
        </S.LeftWrapper>

        {/* right content */}
        <S.RightWrapper>
          {/* price card */}
            <S.ReviewCard>
                <S.TabLabel>
                    <span><LineLoader width="7.2rem" height="2rem"/></span>
                </S.TabLabel>
                <S.TabContent>
                    <S.ContentRow>
                        <LineLoader width="6rem" height="2rem"></LineLoader>
                        <LineLoader width="4rem" height="2rem"></LineLoader>
                    </S.ContentRow>
                    <S.ContentInner>
                        <S.ContentRow>
                            <LineLoader width="6rem" height="2rem"></LineLoader>
                            <LineLoader width="4rem" height="2rem"></LineLoader>
                        </S.ContentRow>
                        <S.ContentRow>
                            <LineLoader width="8rem" height="2rem"></LineLoader>
                            <LineLoader width="4rem" height="2rem"></LineLoader>
                        </S.ContentRow>
                    </S.ContentInner>
                    <S.ContentInner>
                        <S.ContentRow>
                            <LineLoader width="6rem" height="2rem"></LineLoader>
                            <LineLoader width="4rem" height="2rem"></LineLoader>
                        </S.ContentRow>
                        <S.ContentRow>
                            <LineLoader width="8rem" height="2rem"></LineLoader>
                            <LineLoader width="4rem" height="2rem"></LineLoader>
                        </S.ContentRow>
                    </S.ContentInner>
                    <S.ContentInner>
                        <S.ContentRow>
                            <LineLoader width="6rem" height="2rem"></LineLoader>
                            <LineLoader width="6rem" height="2rem"></LineLoader>
                        </S.ContentRow>
                    </S.ContentInner>
                </S.TabContent>
            </S.ReviewCard>

        </S.RightWrapper>
      </S.PageWrapper>
    </section>
  );
};

export default BookingPageLoader;